export type NavType = {
  title: string;
  href: string;
};

export const NAVS: NavType[] = [
  { title: "О бренде", href: "/about" },
  { title: "Каталог", href: "/catalog" },
  { title: "Персонализация", href: "/configurator" },
];
